<template>
  <div style="display: inline-block">
    <div class="top" ref="content">
      <div class="payment-info">
        <div class="payment-name">音乐窝支付单</div>
        <div class="payment-money">
          (待付款
          <span style="color: #45b13b">{{
            Number(originData.amount).toFixed(2)
          }}</span>
          元)
        </div>
        <div class="payment-cancel-time">
          <span> {{ payCodeLimit }} 前支付有效，超时作废 </span>
        </div>
        <div class="payment-qrcode">
          <qrcode-vue
            :value="originData.counter_url"
            :size="127"
            level="M"
            id="qrcode"
          ></qrcode-vue>
        </div>
        <div class="payment-font">扫码付款</div>
        <div class="payment-type flex">
          <div>
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/studying/wechat.png"
              alt=""
            />
          </div>
          <div>
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/studying/alipay.png"
              alt=""
            />
          </div>
        </div>

        <div class="payment-order">
          <div>订单号：{{ originData.order_no }}</div>
          <div>下单时间：{{ getTimestampToTime(originData.create_time) }}</div>
          <div>
            购买学员：{{ originData.student_name
            }}<span v-if="originData.student_mobile"
              >({{
                originData.student_mobile.slice(0, 3) +
                "****" +
                originData.student_mobile.slice(7)
              }})</span
            >
          </div>
          <div>门店信息：{{ $store.state.user.userInfo.org_name }}</div>
          <br />
        </div>
        <div class="buy-content-wrap" v-if="originData.item">
          <div class="buy-content-title">
            <img
              class="icon"
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/finance/pay/goods-icon.png"
            />
            <div class="text">购买内容</div>
          </div>
          <div
            class="buy-content-course"
            v-for="it in originData.item.slice(0, 6)"
            :key="it.course_id"
          >
            <div class="dot"></div>
            <div class="label">
              {{ it.product_name }}({{ it.quantity }}课时)
            </div>
            <div class="price">￥{{ it.sum }}</div>
          </div>
          <div class="dots" v-show="originData.item.length > 6">......</div>
          <div class="total-price">
            共<span class="green">{{ originData.item.length }}</span
            >个课程 合计<span class="green">{{
              originDataItemAmount.toFixed(2)
            }}</span
            >元
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div
        class="payment-order-btn"
        @click="handleDownloadImage"
        v-debounce="1000"
      >
        下载保存
      </div>
    </div>
    <approve-tips-dialog
      :visible.sync="approveDialogVisible"
      :order-id="originData.order_id"
      @close="approveDialogClose"
    ></approve-tips-dialog>
  </div>
</template>

<script>
import { dateFormat } from "@/utils/timeFormat";
import { checkFinishApi } from "@/api/order";
import approveTipsDialog from "@/components/approveTipsDialog.vue";
import html2canvas from "html2canvas";
import QrcodeVue from "qrcode.vue";
import { solveLargeNumber } from "@/utils/common";
export default {
  components: {
    QrcodeVue,
    approveTipsDialog,
  },
  /*
    originData：
      - order_payment_id：支付记录ID，用来检查支付结果
      - item：flat后的课程数组
      - order_id：订单id
      - amount：支付数额
      - efficient_time：支付有效时间
      - counter_url：支付二维码url
      - order_no：订单号
      - create_time：创建时间
      - student_name：学生名称
      - student_mobile：学生手机号
    originPaymentDialogVisible：弹窗是否展示
  */
  props: {
    originData: {
      type: Object,
      default: function () {
        return {
          order_payment_id: "",
          item: [],
          order_id: "",
          amount: 123,
          efficient_time: "",
          counter_url: "",
          order_no: "",
          create_time: "",
          student_name: "",
          student_mobile: "",
        };
      },
    },
    originPaymentDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      approveDialogVisible: false, // 审核弹窗展示
      payCodeLimit: "", // 支付有效期
      originDataItemAmount: 0, // 课程合计价格
    };
  },
  watch: {
    originPaymentDialogVisible: {
      handler() {
        // originData.item为flat后的课程数组，{course_id,course_name,quantity,amount,discount}
        let coursePriceAmount = 0;
        this.originData.item.map((c) => {
          coursePriceAmount =
            (solveLargeNumber(coursePriceAmount) + solveLargeNumber(c.sum)) /
            100;
        });
        this.originDataItemAmount = coursePriceAmount;
        // 线上支付，付款码弹窗打开时，轮询判断此订单是否支付完成
        if (this.originPaymentDialogVisible === true) {
          this.loopCheckFinish();
        }
        this.payCodeLimit = dateFormat(
          "YYYY/mm/dd HH:MM:SS",
          this.originData.efficient_time * 1000
        );
      },
      immediate: true,
      deep: false,
    },
  },
  methods: {
    // 判断订单是否完成支付
    loopCheckFinish() {
      console.log(this.originData);
      checkFinishApi({
        order_payment_id: this.originData.order_payment_id,
      }).then((res) => {
        if (res.data.payment_status === 3) {
          // 需要审批
          if (res.data.approval_id > 0) {
            this.approveDialogVisible = true;
          } else {
            // 不需要审批，当前页是订单详情，更新订单详情数据
            if (this.$route.name === "orderManageDetail") {
              this.$emit("change", false);
            } else {
              // 不是订单详情页，直接跳转
              this.$router.replace({
                name: "orderManageDetail",
                query: {
                  id: String(this.originData.order_id),
                },
              });
            }
          }
        } else {
          if (this.originPaymentDialogVisible) {
            setTimeout(() => {
              this.loopCheckFinish();
            }, 1000);
          }
        }
      });
    },
    // 通知父组件关闭付款码弹窗
    hidePaymentDialog() {
      this.$emit("change", false);
    },
    // 审批组件触发关闭弹窗
    approveDialogClose(v) {
      this.approveDialogVisible = v;
      setTimeout(() => {
        this.hidePaymentDialog();
      }, 100);
    },
    // 获取时间戳转换日期
    getTimestampToTime(time) {
      if (!time) {
        return "-";
      }
      if (typeof time === "string") {
        return time;
      } else {
        return dateFormat("YYYY-mm-dd HH:MM:SS", time * 1000);
      }
    },
    // 下载付款二维码
    handleDownloadImage() {
      let el = this.$refs.content;
      html2canvas(el, {
        useCORS: true, //支持图片跨域
        scale: 1.5, //设置放大的倍数
      }).then((canvas) => {
        let url = canvas.toDataURL("image/png"); // toDataURL: 图片格式转成 base64
        let a = document.createElement("a");
        let event = new MouseEvent("click");
        a.download = "付款码qrcode";
        a.href = url;
        a.dispatchEvent(event);
        a.remove();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  width: 300px;
  padding: 5px 0 0 0;
  background: url("https://wowsite.musicwow.com/teaching_system_frontend/images/studying/codebg2x.png")
    no-repeat;
  background-position: 0 19%;
  background-size: contain;
  border-radius: 10px !important;
  .flex {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .payment-info {
    margin-top: 20px;
    font-style: normal;
    text-align: center;
    font-weight: 400;
    color: rgba(92, 93, 94, 1);
    border-radius: 0 0 10px 10px;

    .payment-name {
      font-size: 19px;
      font-weight: bold;
      line-height: 20px;
    }
    .payment-money {
      height: 20px;
      font-size: 12px;
      font-weight: 400;
      margin-top: 12px;
      line-height: 20px;
    }
    .payment-cancel-time {
      font-size: 10px;
      color: rgba(157, 158, 158, 1);
      line-height: 10px;
    }
    .payment-qrcode {
      margin: 14px auto;
      width: 137px;
      height: 135px;
      background-color: #fff;
    }
    .payment-font {
      font-size: 13px;
      font-weight: bold;
      line-height: 13px;
    }
    .payment-type {
      width: 100%;
      justify-content: space-evenly;
      margin: 12px 0 24px 0;
      div {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        line-height: 16px;
        background-color: #fff;
        img {
          width: 100%;
        }
      }
    }
    .payment-order {
      font-size: 12px;
      font-style: normal;
      line-height: 12px;
      text-align: left;
      margin-left: 52px;
      div:nth-child(2) {
        margin: 9px 0;
      }
      div:nth-child(3) {
        margin: 9px 0;
      }
    }
    .buy-content-wrap {
      border: 1px solid #e5e5e5;
      border-radius: 10px;
      margin: 0 28px 14px 28px;
      overflow: hidden;
      .buy-content-title {
        padding: 10px 15px;
        display: flex;
        align-items: center;
        .icon {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
        .text {
          font-size: 14px;
          line-height: 20px;
          color: #333;
        }
      }
      .buy-content-course {
        display: flex;
        align-items: center;
        color: #9ca1ad;
        font-size: 12px;
        line-height: 24px;
        padding: 0 15px;
        .dot {
          background-color: #333;
          margin-right: 8px;
          width: 2px;
          height: 2px;
          border-radius: 50%;
        }
        .label {
          flex: 1;
          text-align: left;
          white-space: nowrap;
        }
        .price {
        }
      }
      .dots {
        padding: 0 20px;
        color: #9ca1ad;
        font-size: 10px;
        line-height: 10px;
        margin-bottom: 8px;
      }
      .total-price {
        background-color: #f8fafd;
        margin-top: 12px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        color: #333;
        font-weight: bold;
        .green {
          color: #45b13b;
          margin: 0 2px;
        }
      }
    }
  }
}
.bottom {
  &:hover {
    cursor: pointer;
  }
  .payment-order-btn {
    border-radius: 0 0 10px 10px;
    display: inline-block;
    width: 100%;
    height: 40px;
    background: rgba(69, 177, 59, 1);
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }
}

.payment-dialog {
  /deep/ .el-dialog {
    border-radius: 10px !important;
  }
  /deep/ .el-dialog__body {
    // height: 456px !important;
    padding: 0 !important;
    // background: url("https://wowsite.musicwow.com/teaching_system_frontend/images/studying/codebg2x.png")
    //   no-repeat;
    // background-position: 0 30%;
    // background-size: contain;
    border-radius: 10px !important;
  }

  /deep/ .el-dialog__header {
    border: none !important;
    height: 0 !important;
    line-height: 0 !important;
    border: 1px solid red;
  }
}
</style>
